// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__Re2TB","spinner":"styles_spinner__yl5B3","spinnerText":"styles_spinnerText__IfrKk"};